import React, { useState, useReducer } from "react";
import _ from "lodash";
export const EvalContext = React.createContext(null);

const initialState = [
  {
    key: 1,
    x: 0,
    y: 0,
    qmarks: "y",
    index: 0,
  },
];

const qp_template = {
  curval: {},
  parts: [],
  question: [],
  path: [{ fqppath: "", fschempath: "" }],
};

function marksReducer(state, action) {
  switch (action.type) {
    case "INIT_MARKS_TEMPLATE":
      let qpdata = action.payload;
      // let curval = action.payload.question.filter((el) => el.fsubqn != "T")[0];
      return { ...qpdata };
    case "UPDATE_DRAFT_MARKS":
      return { ...action.payload };
    case "SET_CUR_VAL_QN": {
      let fqncode = action.payload.fqncode;
      let curval = state.question.filter((el) => el.fqncode == fqncode)[0];
      if (!curval) return state;
      return { ...state, curval };
    }
    case "INIT_MARKS": {
      let newel = {
        ...action.payload.value,
        fmarks_state: action.payload.fmarks_state,
        fmarks: -1,
      };
      let nquestion = state.question.map((el) => {
        if (el.fqncode === newel.fqncode) {
          return newel;
        } else {
          return el;
        }
      });
      return { ...state, curval: { ...newel }, question: [...nquestion] };
    }
    case "INIT_PARENT_MARKS": {
      let cur = action.payload.value;

      let parent = state.question.filter(
        (el) => el.fqncode == cur.fqnparent
      )[0];
      let curmarks =
        parseFloat(parent.fmarks) == -1 || parent.fmarks == "NA"
          ? 0
          : parseFloat(parent.fmarks);
      let nparent = {
        ...parent,
        fmarks: curmarks,
        fmarks_state: action.payload.fmarks_state,
      };

      let nquestion = state.question.map((el) => {
        if (el.fqncode == cur.fqnparent) {
          return nparent;
        } else {
          return el;
        }
      });
      return { ...state, question: [...nquestion] };
    }
    case "SET_NA": {
      let newel = {
        ...action.payload.value,
        fmarks_state: action.payload.fmarks_state,
        fmarks: "NA",
      };
      let nquestion = state.question.map((el) => {
        if (el.fqncode === newel.fqncode) {
          return newel;
        } else {
          return el;
        }
      });
      return { ...state, curval: { ...newel }, question: [...nquestion] };
    }
    case "SET_NA_PARENT": {
      let curval = action.payload.value;
      if (curval.fqncode == curval.fqnparent) return state;

      let parent = state.question.filter(
        (el) => el.fqncode == curval.fqnparent
      )[0];
      let children = state.question.filter(
        (el) => el.fqnparent == curval.fqnparent && el.fqnparent != el.fqncode
      );
      if (children.length == 0) return state;

      let nchildren = children.map((el) =>
        el.fmarks == "NA"
          ? { ...el, fmarks: -2 }
          : { ...el, fmarks: parseFloat(el.fmarks) }
      );
      let mchildren = nchildren.filter((el) => parseFloat(el.fmarks) >= -1);
      let nparent;
      if (mchildren.length == 0) {
        nparent = { ...parent, fmarks: "NA" };
      } else {
        let sChildren = _.orderBy(nchildren, ["fmarks"], ["desc"]);
        let nmarks = sChildren.slice(0, parent.fsubmandqn).reduce((a, b) => {
          return parseFloat(b.fmarks) > 0
            ? parseFloat(a) + parseFloat(b.fmarks)
            : a;
        }, 0);
        nparent = { ...parent, fmarks: nmarks };
      }

      let nquestion = state.question.map((el) => {
        if (el.fqncode == parent.fqncode) {
          return nparent;
        } else {
          return el;
        }
      });

      return { ...state, question: [...nquestion] };
    }
    case "UPDATE_MARKS": {
      let curmarks =
        parseFloat(state.curval.fmarks) == -1 || state.curval.fmarks == "NA"
          ? 0
          : parseFloat(state.curval.fmarks);
      let nmarks = curmarks + parseFloat(action.payload.qmarks);
      // setTmarks(tmarks + parseFloat(action.payload.qmarks));
      let curval = {
        ...state.curval,
        fmarks: nmarks,
        fmarks_state: "V",
      };
      let xquestion = state.question.map((el) => {
        if (el.fqncode === curval.fqncode) {
          return curval;
        } else {
          return el;
        }
      });
      return { ...state, curval: { ...curval }, question: [...xquestion] };
    }
    case "UPDATE_MARKS_PARENT": {
      let curval = state.curval;
      let nparent;
      let parent = state.question.filter(
        (el) => el.fqncode == curval.fqnparent
      )[0];
      let children = state.question.filter(
        (el) => el.fqnparent == curval.fqnparent && el.fqnparent != el.fqncode
      );
      if (children.length == 0) return state;
      let nchildren = children.map((el) =>
        el.fmarks == "NA"
          ? { ...el, fmarks: -2 }
          : { ...el, fmarks: parseFloat(el.fmarks) }
      );
      let sChildren = _.orderBy(nchildren, ["fmarks"], ["desc"]);
      let nmarks = sChildren.slice(0, parent.fsubmandqn).reduce((a, b) => {
        return parseFloat(b.fmarks) > 0
          ? parseFloat(a) + parseFloat(b.fmarks)
          : a;
      }, 0);
      nparent = { ...parent, fmarks: nmarks };

      let xquestion = state.question.map((el) => {
        if (el.fqncode == curval.fqnparent) {
          return nparent;
        } else {
          return el;
        }
      });
      return { ...state, question: [...xquestion] };
    }
    case "DELETE_MARKS": {
      if (!action.payload.fqncode) {
        return state;
      }
      let images = action.payload.marks_img.filter(
        (el) => el.qkey && el.qkey == action.payload.fqncode
      );
      let nomarks = false;
      if (images.length == 0) nomarks = true;
      let curvaln = state.curval;
      if (state.curval.fqncode == action.payload.fqncode) {
        curvaln = {
          ...state.curval,
          fmarks: nomarks
            ? -1
            : parseFloat(state.curval.fmarks) -
              parseFloat(action.payload.qmarks),
        };
      }
      let dquestion = state.question.map((el) => {
        if (el.fqncode === action.payload.fqncode) {
          let cmarks = action.payload.qmarks;
          let nmarks = nomarks
            ? -1
            : parseFloat(el.fmarks) - parseFloat(cmarks);
          return { ...el, fmarks: nmarks };
        } else {
          return el;
        }
      });
      return { ...state, question: [...dquestion], curval: { ...curvaln } };
    }
    case "DELETE_MARKS_PARENT": {
      if (!action.payload.fqncode) {
        return state;
      }
      let qncode = action.payload.fqncode;
      let nparent;
      let curval = state.question.filter((el) => el.fqncode == qncode)[0];
      if (curval.fqncode == curval.fqnparent) return state;
      let parent = state.question.filter(
        (el) => el.fqncode == curval.fqnparent
      )[0];
      let children = state.question.filter(
        (el) => el.fqnparent == curval.fqnparent && el.fqnparent != el.fqncode
      );
      if (children.length == 0) return state;
      let nchildren = children.map((el) =>
        el.fmarks == "NA"
          ? { ...el, fmarks: -2 }
          : { ...el, fmarks: parseFloat(el.fmarks) }
      );
      let sChildren = _.orderBy(nchildren, ["fmarks"], ["desc"]);
      let nmarks = sChildren.slice(0, parent.fsubmandqn).reduce((a, b) => {
        return parseFloat(b.fmarks) > 0
          ? parseFloat(a) + parseFloat(b.fmarks)
          : a;
      }, 0);
      nparent = { ...parent, fmarks: nmarks };

      let xquestion = state.question.map((el) => {
        if (el.fqncode == curval.fqnparent) {
          return nparent;
        } else {
          return el;
        }
      });
      return { ...state, question: [...xquestion] };
    }
    default:
      return state;
  }
}

function marksImgreducer(state, action) {
  switch (action.type) {
    case "UPDATE_DRAFT_IMAGE":
      return [...action.payload];
    case "ADD_MARKS_IMAGE":
      const item = {
        key: action.payload.key,
        x: action.payload.x,
        y: action.payload.y,
        qmarks: action.payload.qmarks,
        index: action.payload.index,
        qkey: action.payload.qkey,
      };
      return [...state, item];
    case "DELETE_MARKS_IMAGE":
      const newState = state.filter((el) => el.key !== action.payload.key);
      return [...newState];
    case "DELETE_MARKS_IMAGE_QUESTION":
      const newState1 = state.filter(
        (el) => el.qkey !== action.payload.fqncode
      );
      return [...newState1];
    default:
      return [...state];
  }
}

function messgeBoxReducer(state, action) {
  switch (action.type) {
    case "CLOSE_MSG_BOX":
      return { open: false, header: "", message: "", color: "" };
    case "OPEN_MSG_BOX":
      let color =
        action.payload.header.toLowerCase() == "error" ? "#e53935" : "#388e3c";
      return {
        open: true,
        header: action.payload.header,
        message: action.payload.message,
        color: color,
      };
    default:
      return state;
  }
}

function imgreducer(state, action) {
  switch (action.type) {
    case "SET_IMAGES":
      return [...action.payload];
    default:
      return [...state];
  }
}

export default ({ children }) => {
  const initMgsState = { open: false, header: "", message: "", color: "" };

  const [message, dispatch_msg] = useReducer(messgeBoxReducer, initMgsState);

  const [tmarks, setTmarks] = useState(0);

  const [pointerClass, setPointerClass] = useState("");
  // const [images, setImages] = useState([]);
  const [isImgSel, setImgSel] = useState(false);
  const [curValQn, setcurValQn] = useState({});
  const [subInfo, setsubInfo] = useState({});
  const [qmarks, setQmarks] = useState(0);
  // const [tmarks, setTmarks] = useState(0);

  const [images, dispatch_img] = useReducer(imgreducer, initialState);

  const [marks, dispatch_marks] = useReducer(marksReducer, qp_template);

  const [marks_img, dispatch_marks_img] = useReducer(
    marksImgreducer,
    initialState
  );

  const evalStore = {
    subject: [subInfo, setsubInfo],
    pointer: [pointerClass, setPointerClass],
    gallery: [images, dispatch_img],
    imgSelState: [isImgSel, setImgSel],
    qmarks: [qmarks, setQmarks],
    tmarks: [tmarks, setTmarks],
    marks_img_state: [marks_img, dispatch_marks_img],
    markslist: [marks, dispatch_marks],
    curval: [curValQn, setcurValQn],
    message: [message, dispatch_msg],
  };

  return (
    <EvalContext.Provider value={evalStore}>{children}</EvalContext.Provider>
  );
};
